import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MenuSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MenuSVG;
